var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressbar100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 4,
    viewBox: "0 0 150 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "ProgressBar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Done") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M0 2C0 0.895431 0.895431 0 2 0H148C149.105 0 150 0.895431 150 2V2C150 3.10457 149.105 4 148 4H2C0.895429 4 0 3.10457 0 2V2Z",
    fill: "#2E853F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressbar100);
export default __webpack_public_path__ + "static/media/progressbar100.3cc9401ff844416420dfc53ee2a1a8e9.svg";
export { ForwardRef as ReactComponent };